<!-- <div class="container" *ngIf="rowData && rowData.length > 0">
  <ag-grid-angular 
      style="width: 100%;height: 55vh;"
      class="ag-theme-alpine"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="rowData"
      [rowSelection]="'multiple'"
      [animateRows]="true"   
      (cellClicked)="onCellClicked($event)" 
  ></ag-grid-angular>
</div> -->


 <!-- <div fxLayout="row" >
    <div class="pagination-controls" fxFlex="100">
        <div class="pagination">
            <button class="mat-button-prev" mat-raised-button (click)="goToPage(1)" [disabled]="currentPage === 1 || !rowData.length ">First</button>
            <button class="mat-button-prev" mat-raised-button (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
            <span class="page-button">Page {{ currentPage }}</span>
            <button class="mat-button-prev" mat-raised-button (click)="nextPage()" [disabled]="currentPage === totalPages || !rowData.length">Next</button>
            <button class="mat-button-prev" mat-raised-button (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages || !rowData.length">Last</button>
        </div>
  
          <div class="items">
            <mat-form-field appearance="outline">
              <mat-select placeholder="{{ defaultPlaceholder }}" [(value)]="pageSize" (selectionChange)="onPageSizeChange($event)">
                <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} items per page</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      </div>
 </div> -->
  
 <hr class="horizontal-line">
 <div class="container" *ngIf="rowData && rowData.length > 0">
  <table class="table full-width">
    <thead>
      <tr>
        <th>ID</th>
        <th>Name</th>
        <th>Verified E-Mail</th>
        <th>Brand</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of rowData">
        <td><a (click)="navigateToUserInfo(item.id)">{{ item.id }}</a></td>
        <td>{{ item.name }}</td>
        <td><a (click)="navigateToUserInfo(item.id)">{{ item.verified_email }}</a></td>
        <td>{{ item.brand }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="dataFetched && rowData && rowData.length === 0" class="no-data-message">
  No Record found
</div>


